<template>
  <a-select
    :mode="mode"
    v-model="clientsProxy"
    :allow-clear="true"
    :placeholder="loadingClients ? 'Loading...' : 'Client'"
    :loading="loadingClients"
    :disabled="disabled"
    :filter-option="filterOption"
    @popupScroll="handleScroll"
  >
    <template slot="suffixIcon">
      <a-icon v-if="loadingClients" type="loading" />
    </template>
    <a-select-option v-for="client in clients.items" :key="client.id" :value="client.id">
      {{ client.name }}
    </a-select-option>
  </a-select>
</template>

<script>
import { Icon, notification, Select } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'
const { mapActions: projectActions } = createNamespacedHelpers('project')

export default {
  components: {
    'a-select': Select,
    'a-select-option': Select.Option,
    'a-icon': Icon
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String || Array,
      default: undefined
    },
    multiply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clients: {
        items: [],
        page: 0,
        total_count: 0
      },

      loadingClients: false
    }
  },
  computed: {
    mode() {
      return this.multiply ? 'multiple' : 'default'
    },

    clientsProxy: {
      get() {
        if (this.loadingClients) {
          return undefined
        }

        if (Array.isArray(this.value)) {
          return this.value.map(Number)
        }

        return this.value ? Number(this.value) : undefined
      },
      set(value) {
        this.$emit('update:value', value)
      }
    }
  },
  methods: {
    ...projectActions(['getClients']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    async fetchClients() {
      if (this.clients.total_count > 0 && this.clients.items.length >= this.clients.total_count) {
        return
      }

      this.loadingClients = true

      const payload = {
        page: this.clients.page + 1,
        size: 50,
        fields: '{id,name}'
      }

      try {
        const data = await this.getClients(payload)

        if (!this.clients.items.length) {
          this.clients = data
        } else {
          this.clients.items = this.clients.items.concat(data.items)
          this.clients.page += 1
        }
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loadingClients = false
      }
    },

    handleScroll(event) {
      const { target } = event
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
        this.fetchClients()
      }
    }
  },
  async mounted() {
    await this.fetchClients()
  }
}
</script>

<style scoped></style>
